// i18n area 'hci' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.tr-TR.meta.json.
import type { enUS } from './hci'

export const trTR: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph kümeleri',
      createButton: 'Ceph kümesi oluştur',
      emptyTitle: 'Yönetilen Ceph kümesi yok',
      emptyBody: "TVirt, Ceph'i üye düğümlere dağıtır ve sahipliğini üstlenir; VM iş yüküyle hiperbütünleşik çalışır. Bir küme oluşturun: ilk monitor ve onun manager'ı, seçilen kontrol düğümünde otomatik olarak doğar — sonra kümeyi daha fazla monitor ve OSD aygıtıyla büyütün.",
      pageTitle: 'Ceph kümeleri',
      colState: 'Durum',
      colMembers: 'Üyeler',
      colSize: 'Boyut',
      colVersion: 'Ceph sürümü',
      sizeCell: 'toplam {total} GiB alanın {used} GiB kadarı kullanımda',
      phase: {
        'not-deployed': 'Dağıtılmadı',
        deploying: 'Dağıtılıyor',
        healthy: 'Sağlıklı',
        degraded: 'Bozulmuş',
        error: 'Hata',
        destroying: 'Yok ediliyor',
        destroyed: 'Yok edildi'
      },
      health: {
        HEALTH_OK: 'Sağlıklı (HEALTH_OK)',
        HEALTH_WARN: 'Uyarılar var (HEALTH_WARN)',
        HEALTH_ERR: 'Hata durumunda (HEALTH_ERR)',
        unknown: 'Henüz gözlemlenmedi',
        observedAt: '{time} gözlemlendi'
      },
      create: {
        title: 'Ceph kümesi oluştur',
        info: "Yeni bir Ceph kümesi oluşturulurken MON ve MGR rollerinin kurulacağı ilk düğüm seçilir. Ayrıca Ceph trafiği için hangi alt ağın kullanılacağı da belirtilmelidir: public alt ağı genel ağ trafiği için kullanılır, cluster alt ağı ise OSD'ler arasındaki iç replikalar için kullanılır; farklı alt ağlar şart değildir.",
        controlNode: 'Kontrol düğümü',
        controlNodeHint: "İlk MON + MGR'nin doğduğu üye düğüm.",
        publicSubnet: 'Public alt ağı',
        publicSubnetHint: "IPAM'de kayıtlı bir Subnet — Ceph'in public_network'ü. Oluşturmadan sonra değiştirilemez.",
        clusterSubnet: 'Cluster alt ağı',
        clusterSubnetHint: "IPAM'de kayıtlı bir Subnet — Ceph'in cluster_network'ü (replikasyon/backfill).",
        noSubnets: "Kayıtlı Subnet yok — önce IPAM'de oluşturun",
        sameSubnet: 'Public ve cluster trafiği için aynı alt ağ',
        sameSubnetHint: 'İşaretli = cluster ağı (replikasyon/backfill) public ile örtüşür. İşaretsiz = ona ayrı bir alt ağ VE kontrol düğümünün bu alt ağ içindeki adresini seçin.',
        controlAddress: 'Kontrol düğümü adresi',
        controlAddressHint: "IPAM'in public alt ağı içinde düğüm için bildiği bir adres.",
        controlClusterAddress: 'Kontrol düğümünün cluster adresi',
        controlClusterAddressHint: "IPAM'in cluster alt ağı içinde düğüm için bildiği bir adres.",
        noAddresses: 'IPAM, seçilen alt ağ içinde bu düğümün hiçbir adresini bilmiyor',
        started: 'Küme oluşturuldu — bootstrap makro görev olarak sürer; aşama kendiliğinden güncellenir',
        error: 'Küme reddedildi'
      },
      detail: {
        actions: 'Kullanılabilir eylemler',
        tabOverview: 'Genel bakış',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Havuzlar',
        tabObjects: 'Nesneler',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Gelişmiş',
        phase: 'Aşama',
        checksTitle: 'Etkin sağlık denetimleri',
        noChecks: 'Etkin sağlık denetimi yok',
        checkMuted: 'susturuldu',
        summaryPools: 'Havuzlar',
        summaryFilesystems: 'Dosya sistemleri',
        nodesCard: 'Düğümler',
        monHint: "Her MON ile birlikte konumlanmış bir MGR çalışır. Önerilen quorum üç MON'dur; bir laboratuvar kümesi tek MON ile başlar. OSD'ler ve MDS'ler kendi sekmelerinde yaşar.",
        monHintSplit: "Bu kümede MON ve MGR ayrık (Gelişmiş): her rol, düğüm başına kendi üyeliğidir. Önerilen quorum üç MON'dur; en az bir MGR var olmalıdır.",
        noMons: 'Bildirilen monitor yok',
        addNode: 'Düğüm ekle',
        removeNode: 'Düğümü kaldır',
        removeNodeFrom: "'{node}' düğümünü kaldır (MON'u ve birlikte konumlanan MGR'si)",
        roleMon: 'MON rolü',
        roleMgr: 'MGR rolü',
        roleNa: 'N/A',
        roleNotObserved: 'henüz gözlemlenmedi',
        monInQuorum: 'quorumda',
        monOutQuorum: 'quorum dışında',
        mgrActive: 'etkin',
        mgrStandby: 'standby',
        addRoleMon: 'MON rolü ekle',
        removeRoleMon: 'MON rolünü kaldır',
        addRoleMgr: 'MGR rolü ekle',
        removeRoleMgr: 'MGR rolünü kaldır',
        restartMon: 'MON hizmetini yeniden başlat',
        restartMgr: 'MGR hizmetini yeniden başlat',
        addMon: 'MON ekle',
        removeMon: "MON'u kaldır",
        removeMonFrom: "'{node}' düğümünden MON rolünü kaldır",
        addMgr: 'MGR ekle',
        removeMgr: "MGR'yi kaldır",
        removeMgrFrom: "'{node}' düğümünden MGR rolünü kaldır",
        addMds: 'MDS ekle',
        removeMds: "MDS'yi kaldır",
        removeMdsFrom: "'{node}' düğümünden MDS rolünü kaldır",
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Bildirilen MDS yok — bir dosya sistemi önce bir tane gerektirir',
        mdsHint: "MDS üyeliği ilk günden kendi başınadır: CephFS'siz bir küme hiç MDS bildirmez; bir etkin artı bir standby, bir dosya sistemine iyi hizmet eder. Ceph, etkinleri ve standby'ları bildirilen daemon'lar arasından seçer.",
        mdsActiveFor: 'etkin — {fs}',
        mdsNotObserved: 'henüz gözlemlenmedi',
        lastMdsGuard: 'Bir dosya sistemi var olduğu sürece son MDS kaldırılamaz — önce dosya sistemlerini kaldırın',
        lastMonGuard: 'Son MON kaldırılamaz — tek çıkış kümeyi yok etmektir',
        lastMgrGuard: 'Son MGR kaldırılamaz — yönetilen bir küme asla manager olmadan çalışmaz',
        registerDevice: 'OSD ekle',
        unregisterDevice: 'Kaydı kaldır',
        activeDeviceGuard: 'Etkin OSD — kayıttan değil, OSD yaşam döngüsü üzerinden çıkar',
        colNode: 'Düğüm',
        devicePhase: { registered: 'Kayıtlı', active: 'Etkin' },
        health: 'Sağlık',
        state: 'Durum',
        fsid: 'fsid',
        fsidPending: "yok — bootstrap'i yeniden deneyin",
        version: 'Ceph sürümü',
        publicNetwork: 'Public ağı',
        clusterNetwork: 'Cluster ağı',
        clusterNetworkCollapsed: '= public',
        noActions: 'Bu aşamada kullanılabilir eylem yok',
        destroyedNote: 'Küme yok edildi — satır kısa süre içinde otomatik olarak kaldırılır'
      },
      overview: {
        services: 'Hizmetler',
        ok: 'sağlıklı',
        warning: 'warning',
        down: 'çalışmıyor',
        pgTitle: 'PG durumları',
        pgTotal: 'toplam {n} PG',
        capacityTitle: 'Alan',
        ioTitle: 'Anlık I/O',
        ioReadBw: 'Okuma bant genişliği',
        ioWriteBw: 'Yazma bant genişliği',
        ioReadIops: 'Okuma IOPS',
        ioWriteIops: 'Yazma IOPS',
        notObserved: 'henüz gözlemlenmedi'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Durum',
        colSize: 'Boyut',
        colPgs: 'PG',
        empty: 'OSD yok — bildirilen bir veri diskinden bir tane ekleyin',
        markIn: 'IN olarak işaretle',
        markOut: 'OUT olarak işaretle',
        scrub: 'Scrub çalıştır',
        deepScrub: 'Derin scrub çalıştır',
        restart: 'Hizmeti yeniden başlat',
        details: 'Ayrıntılar',
        actionGuard: "Yalnızca dağıtılmış bir kümenin etkin bir OSD'sinde",
        inTitle: "OSD'yi IN olarak işaretle",
        inBody: 'osd.{id} veri dağılımına geri döner (ceph osd in): Ceph verileri yeniden onun üzerine dengeler.',
        outTitle: "OSD'yi OUT olarak işaretle",
        outBody: "osd.{id} veri dağılımından çıkar (ceph osd out): verileri başka yerlere yeniden dengelenir ve backfill çalıştığı sürece artıklık AZALMIŞ olur. 'IN olarak işaretle' ile her an geri döndürülebilir.",
        scrubTitle: 'Scrub zamanla',
        scrubBody: "osd.{id} için bir scrub zamanlanır: mon onu kuyruğa alır ve sonucu izleyen sweep'lerin PG durumları anlatır.",
        deepScrubTitle: 'Derin scrub zamanla',
        deepScrubBody: 'osd.{id} için derin bir scrub zamanlanır: baytları doğrulayan varyant — I/O üzerinde daha ağır, mekanik aynı.',
        restartTitle: 'OSD hizmetini yeniden başlat',
        restartBody: "osd.{id}, kendi düğümündeki worker'ın gözetimiyle durdurulur ve yeniden başlatılır.",
        started: 'Eylem başlatıldı — gözlem kendiliğinden güncellenir',
        error: 'OSD eylemi reddedildi'
      },
      osdDetail: {
        title: 'OSD ayrıntıları',
        tabGeneral: 'Genel',
        tabNetwork: 'Ağ',
        tabDevices: 'Aygıtlar',
        version: 'Sürüm',
        hostname: 'Hostname',
        dataPath: 'OSD veri yolu',
        objectStore: 'OSD object store',
        encrypted: 'Şifrelenmiş',
        yes: 'Evet',
        no: 'Hayır',
        memory: 'Bellek kullanımı (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front adresi (client & monitor)',
        hbFront: 'Heartbeat front adresi',
        back: 'Back adresi (OSD)',
        hbBack: 'Heartbeat back adresi',
        colDevice: 'Device',
        colType: 'Tür',
        colPhysical: 'Fiziksel device',
        colSize: 'Boyut',
        volumeTitle: 'Birim ayrıntıları',
        creationTime: 'Oluşturulma zamanı',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Bu OSD için gözlemlenen device yok'
      },
      restart: {
        title: 'Hizmeti yeniden başlat',
        monBody: "'{node}' düğümündeki MON daemon'ı, worker'ın gözetimiyle durdurulur ve yeniden başlatılır.",
        mgrBody: "'{node}' düğümündeki MGR daemon'ı, worker'ın gözetimiyle durdurulur ve yeniden başlatılır.",
        started: 'Yeniden başlatma başlatıldı — gözlem kendiliğinden güncellenir',
        error: 'Yeniden başlatma reddedildi'
      },
      encryptionMode: {
        alwaysOn: 'Her zaman etkin (dmcrypt)',
        alwaysOff: 'Her zaman devre dışı',
        perOsd: 'OSD başına seçilir',
        section: 'OSD şifrelemesi (at rest)',
        title: 'OSD şifreleme modunu değiştir',
        hint: "YENİ OSD'lerin nasıl hazırlanacağını belirler. Mevcut OSD'ler disk başına durumlarını korur: birini değiştirmek için OSD kaldırılır ve yeniden oluşturulur.",
        body: 'Mod "{mode}" olur ve YALNIZCA YENİ OSD\'ler için geçerlidir: mevcut her OSD, geçerli şifreleme durumunu korur.',
        apply: 'Modu değiştir',
        error: 'Mod değişikliği reddedildi'
      },
      pin: {
        address: 'Public adresi (isteğe bağlı pin)',
        clusterAddress: 'Cluster adresi (isteğe bağlı pin)',
        autoPlaceholder: '{cidr} alt ağında otomatik',
        hint: 'Daemon başına adresleme: boş = Ceph, bildirilen ağ içinde kendiliğinden bağlanır; dolu = bu daemon örneği, kendi conf bölümündeki adrese sabitlenir.'
      },
      addMon: {
        title: 'Düğüm ekle',
        node: 'Düğüm',
        address: 'Public adresi',
        addressHint: "IPAM'in public alt ağı içinde bu düğüm için bildiği adresler — mevcut bir bildirim düğümü kapsadığında otomatik seçilir.",
        clusterAddress: 'Cluster adresi',
        clusterAddressHint: 'Zorunlu: cluster alt ağı ayrıdır ve düğüm orada henüz bildirilmedi.',
        noAddresses: 'IPAM, alt ağ içinde bu düğümün hiçbir adresini bilmiyor',
        error: 'Mon ekleme reddedildi'
      },
      removeMon: {
        title: "MON'u kaldır",
        body: "MON ve onunla birlikte konumlanan MGR, '{node}' düğümünden ayrılır. Dağıtılmış bir kümede daemon'lar durdurulur ve quorumdan çıkarılır.",
        error: 'MON kaldırma reddedildi'
      },
      addMgr: {
        title: 'MGR ekle',
        node: 'Düğüm',
        hint: "Gelişmiş (ayrık MON/MGR): seçilen üye düğümde, düğüme bağlı bir görevle bağımsız bir manager doğar. Ceph'in kendi active/standby seçimi etkin MGR'yi belirler.",
        error: 'MGR ekleme reddedildi'
      },
      removeMgr: {
        title: "MGR'yi kaldır",
        body: "Bağımsız MGR, '{node}' düğümünden ayrılır. Dağıtılmış bir kümede daemon durdurulur ve durumu kaldırılır; düğümün MON'una (varsa) dokunulmaz.",
        error: 'MGR kaldırma reddedildi'
      },
      addMds: {
        title: 'MDS ekle',
        node: 'Düğüm',
        hint: "CephFS'in metadata server'ı: seçilen üye düğümde, düğüme bağlı bir görevle doğar; MON ve MGR gibi worker gözetimindedir. Ceph, etkinleri ve standby'ları kendi başına seçer — bir etkin artı bir standby, bir dosya sistemine iyi hizmet eder.",
        error: 'MDS ekleme reddedildi'
      },
      removeMds: {
        title: "MDS'yi kaldır",
        body: "MDS, '{node}' düğümünden ayrılır. Dağıtılmış bir kümede daemon durdurulur ve durumu kaldırılır; bir dosya sistemi ona ihtiyaç duyduğu sürece API son MDS'yi reddeder.",
        error: 'MDS kaldırma reddedildi'
      },
      split: {
        title: 'Ayrık MON/MGR',
        label: "MON ve MGR'nin ayrık düğümlerde olmasına izin ver",
        hint: 'Kapalı (varsayılan) = onaylanmış standart: her MON ile birlikte konumlanan bir MGR, tek üyelik. Açık = MGR üyeliği kendi başına olur ve Yönetim düğümleri sekmesindeki MGR Ekle/Kaldır eylemleriyle yönetilir.',
        enable: 'Etkinleştir',
        disable: 'Devre dışı bırak',
        enableBody: "MGR üyeliği MON'lardan bağımsız hale gelir ve geçerli birlikte konumlanmadan başlatılır. Bağımsız MGR Ekle/Kaldır eylemleri Yönetim düğümleri sekmesinde etkinleşir. Bu, platform varsayılanını gevşetir — yalnızca neden gerektiğini biliyorsanız açık tutun.",
        disableBody: "Standart birlikte konumlanmaya dönüş: her MON ile bir MGR, tek üyelik. Yalnızca MGR üyeliği MON'larla zaten örtüşüyorsa geçerlidir — önce MGR Ekle/Kaldır ile hizalayın, yoksa API reddeder.",
        error: 'Değişiklik reddedildi'
      },
      rawEditor: {
        title: 'Ham CRUSH düzenleyicisi',
        label: 'CRUSH sekmesinde ham crushmap düzenleyicisini göster',
        hint: "Kapalı (varsayılan) = kılavuzlu kural yüzeyi standart araçtır. Açık = CRUSH sekmesi, decompile edilmiş crushmap'i düzenlenebilir metin olarak da gösterir. Kaydetme her zaman sudo ister, onay olarak küme adını gerektirir ve kümeye ulaşmadan ÖNCE crushtool compile + test aşamalarından geçer."
      },
      osdFlags: {
        section: 'Genel OSD bayrakları',
        title: "OSD bayrak override'ı",
        notObserved: 'henüz gözlemlenmedi',
        standardFlowsHint: 'Platformun standart akışları, normal durumlarda bu bayrakları kendi başına yönetir (düğüm bakımı hedefli bir noout ayarlar, disk değişimi OSD yaşam döngüsünden geçer). Bu bölüm, ne yaptığını bilen operatör için manuel override alanıdır.',
        notDeployedGuard: 'OSD bayrakları yalnızca dağıtılmış bir kümede var olur',
        set: 'Bayrağı ayarla',
        unset: 'Bayrağı kaldır',
        setBody: 'Genel {flag} bayrağı osdmap üzerinde AYARLANACAK. Açıkça kaldırılana kadar kalır — unutulmuş bir bayrak kümenin kendi kendini onarmasını zayıflatır.',
        unsetBody: "Genel {flag} bayrağı osdmap'ten KALDIRILACAK.",
        error: 'Bayrak değişikliği reddedildi',
        flag: {
          noout: 'Hiçbir OSD veri dağılımının dışına out olarak işaretlenmez — bir daemon kaybında yeniden dengeleme olmaz',
          norebalance: 'Verilerin yeniden dengelenmesi askıya alınır',
          nobackfill: 'Backfill askıya alınır',
          norecover: 'Recovery askıya alınır',
          pause: "TÜM client I/O'su duraklatılır (okumalar ve yazmalar)",
          noin: "Başlamakta olan OSD'ler otomatik olarak in işaretlenmez",
          nodown: "Erişilemeyen OSD'ler down olarak işaretlenmez — gerçek arızaları maskeler"
        }
      },
      pools: {
        section: 'Havuzlar',
        create: 'Havuz oluştur',
        createGuard: 'Havuzlar yalnızca dağıtılmış bir kümede var olur',
        notObserved: "Havuz gözlemi yok — mon sweep'i buraya raporlar",
        empty: 'Kümede havuz yok',
        colName: 'Ad',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Uygulama',
        colRule: 'CRUSH kuralı',
        colUsage: 'Kullanım',
        observedAtLabel: 'Gözlemlenme zamanı',
        objects: '{n} nesne',
        inUseBy: '{name} tarafından kullanılıyor',
        internalGuard: "Ceph'in iç havuzu — platform onu asla silmez",
        delete: 'Havuzu sil',
        deleteGuard: "'{name}' depolaması tarafından tüketiliyor — önce depolamayı silin",
        hint: "Yalnızca replikalı havuzlar (erasure coding v1 scope dışında). Replikasyon Ceph'te yaşar: bu tablo, mon sweep'inden gözlemlenen gerçektir.",
        createTitle: 'Havuz oluştur',
        createHint: 'Havuz, istenen replikasyonla ve rbd uygulaması etkin olarak kümede doğar — işi bir MON düğümündeki görev yapar. Aynı harekette hemen tüketmek için "Depolama olarak öner" seçeneğini açın.',
        name: 'Havuz adı',
        nameHint: 'DNS-safe (küçük harfler, rakamlar, tireler).',
        size: 'Replikalar (size)',
        sizeHint: 'Her nesnenin kopyaları. Varsayılan 3.',
        minSize: 'En az replika (min_size)',
        minSizeHint: 'I/O sunmak için en az kopya sayısı — siz düzenleyene kadar size − 1 değerini izler.',
        createError: 'Havuz oluşturma reddedildi',
        deleteTitle: 'Havuzu sil',
        deleteBody: "'{pool}' havuzu ve içindeki HER nesne geri dönülmez biçimde yok edilir. Onaylamak için havuzun adını yazın.",
        confirmLabel: 'Havuz adı',
        confirmHint: 'Onaylamak için havuzun adını yazın',
        deleteError: 'Havuz silme reddedildi',
        detailTitle: 'Havuz ayrıntıları',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Etkin',
        autoscalerOff: 'Devre dışı',
        autoscalerWarn: 'Bildir',
        pgNumLabel: 'PG sayısı',
        pgNumCaption: 'Gözlemlenen: autoscaler bunu kendi başına değiştirebilir — bu alan bir istek yazar.',
        storage: 'İlişkili TVirt depolaması',
        addAsStorage: 'TVirt depolaması olarak ekle',
        ruleSudoHint: 'CRUSH kuralını değiştirmek operatör parolasını gerektirir.',
        updateError: 'Havuz güncellemesi reddedildi',
        updated: 'Havuz güncellemesi başlatıldı — gözlem kendiliğinden güncellenir'
      },
      crush: {
        section: 'CRUSH kuralları',
        notObserved: "Henüz CRUSH gözlemi yok — mon sweep'i buraya raporlar",
        empty: 'Kümede gözlemlenen kural yok',
        hint: 'Bir kural, her nesnenin kopyalarının NEREYE düşeceğine karar verir — hata etki alanı, veri kaybı olmadan arızalanabilecek birimdir. Havuzlar bir kurala işaret eder; builtin replicated_rule (sunucu başına bir replika) doğuş varsayılanıdır.',
        create: 'Kural oluştur',
        createGuard: 'CRUSH kuralları yalnızca dağıtılmış bir kümede var olur',
        createTitle: 'CRUSH kuralı oluştur',
        createHint: 'Bir kural = bir hata etki alanı seçimi. Kural, varsayılan root üzerinde replikalı olarak doğar — işi bir MON düğümündeki görev yapar; havuzları sonra Havuzlar sekmesinden ilişkilendirin.',
        createError: 'Kural oluşturma reddedildi',
        name: 'Kural adı',
        nameHint: 'DNS-safe (küçük harfler, rakamlar, tireler).',
        domain: 'Hata etki alanı',
        domainChoice: {
          osd: 'Her replika farklı bir OSD üzerinde',
          host: 'Her replika farklı bir sunucu üzerinde',
          rack: 'Her replika farklı bir rack içinde'
        },
        domainCustom: 'Özel (elle yazılmış adımlar)',
        domainOther: 'Her replika farklı bir {type} içinde',
        rackGuardHint: "Gözlemlenen hiyerarşide hiçbir rack bucket'ı yok: kural yine de oluşturulabilir, ama üye sunucuların yerleşiminde (düğüm ayarları) bir rack bildirilene kadar hiçbir havuz ona yönlendirilemez — yeniden hizalama görevi bucket'ı kurar ve ilişkilendirme kendiliğinden açılır.",
        treeTitle: 'Gözlemlenen hiyerarşi',
        treeNotObserved: "Hiyerarşi gözlemi yok — mon sweep'i buraya raporlar",
        treeOsds: '{n} OSD',
        treeHint: "CRUSH haritası, kümenin gördüğü haliyle: root → bildirilen düzeyler → sunucular (hostlar) → OSD'ler. Topoloji, her sunucunun bildirilen yerleşimini izler (düğüm ayarları) — bir konum değişikliği onu görev aracılığıyla yeniden hizalar.",
        unplacedWarning: 'Yerleşimi bildirilmemiş üyeler: {nodes} — hostları doğrudan root altında, bildirilen topolojinin dışında kalır. Konumu düğüm ayarlarında bildirin (bir uyarı, asla bir engel değil).',
        colName: 'Ad',
        colDomain: 'Hata etki alanı',
        colPools: 'Havuzlar',
        builtinChip: 'builtin',
        builtinGuard: 'Kümenin varsayılan kuralı — platform onu asla silmez',
        detailAction: 'Kural ayrıntısı',
        detailType: 'Tür',
        backToRules: 'Kurallar',
        ruleNotObserved: 'Gözlemlenen kural listesi bu kuralı anmıyor',
        noPools: 'Bu kuralı kullanan havuz yok',
        delete: 'Kuralı sil',
        deleteTitle: 'CRUSH kuralını sil',
        deleteBody: "'{rule}' kuralı kümenin crushmap'inden kaldırılır. Hiçbir havuz onu kullanmıyor olmalı. Onaylamak için kuralın adını yazın.",
        deleteGuard: "'{name}' havuzu tarafından kullanılıyor — önce havuzu başka bir kurala yönlendirin",
        confirmLabel: 'Kural adı',
        confirmHint: 'Onaylamak için kuralın adını yazın',
        deleteError: 'Kural silme reddedildi',
        changeRule: 'CRUSH kuralını değiştir',
        changeRuleTitle: 'CRUSH kuralını değiştir',
        changeRuleHint: 'Havuz, nesnelerini seçilen kurala göre yerleştirmeye başlar — Ceph mevcut verileri uyum için taşır (dolu bir havuzda bunu bir yeniden dengeleme izler).',
        changeRuleError: 'Kural değişikliği reddedildi',
        rule: 'CRUSH kuralı',
        rawTitle: 'Ham crushmap (decompile edilmiş)',
        rawWarning: "TEHLİKE: bu metin kümenin TÜM yerleşim politikasıdır. Yanlış bir harita tüm havuzların placement'ını bir anda bozabilir. Kaydetme, haritayı enjekte etmeden ÖNCE crushtool ile derler ve sınar — ama geçerli bir harita yine de kötü bir fikir olabilir.",
        rawReload: 'Yeniden yükle',
        rawLoading: "Sorgu yürütülüyor — read-only bir görev crushmap'i decompile ediyor…",
        rawSave: "Crushmap'i kaydet",
        rawSaveTitle: "Crushmap'i enjekte et",
        rawSaveBody: "Düzenlenen metin, crushtool compile + test sonrasında TÜM kümenin crushmap'ini değiştirir. Onaylamak için küme adını yazın.",
        rawConfirmLabel: 'Küme adı',
        rawConfirmHint: 'Onaylamak için {name} yazın',
        rawError: 'Crushmap işlemi başarısız oldu',
        rawHint: "Metin, crushtool -d biçimidir. Derleme ve test hataları crushtool'dan kelimesi kelimesine döner — iki kapıdan biri başarısız olursa harita kümeye ulaşmaz."
      },
      objects: {
        poolsSection: 'Nesne gezgini',
        poolsHint: 'RBD görüntülerini listelemek için bir havuz seçin. Her derin okuma, bir MON düğümünde read-only bir görev olarak çalışır — gerçek işlemleri engellemez (onlar tarafından da engellenmez).',
        deployedGuard: 'Nesne sorguları yalnızca dağıtılmış bir kümede yanıt verir',
        browse: 'Nesnelere göz at',
        detailAction: 'Görüntü ayrıntısı',
        backToPools: 'Havuzlar',
        backToImages: 'Görüntüler',
        refresh: 'Yenile',
        loading: 'Sorgu yürütülüyor — read-only bir görev kümeyi sorguluyor…',
        error: 'Sorgu başarısız oldu',
        retry: 'Yeniden dene',
        notRbd: 'Uygulaması "{app}" olan havuz — RBD görüntüsü içermiyor, burada keşfedilecek bir şey yok',
        noImages: 'Bu havuzda RBD görüntüsü yok',
        colImage: 'Görüntü',
        colSize: 'Boyut',
        colObjects: 'Nesneler',
        colSnapshots: 'Anlık görüntüler',
        imagesHint: "Tüketen bir rbd depolamasındaki diskler, disk id'leriyle adlandırılmış görüntülerdir. Nesne sayısı provisioned değerdir (boyut / nesne boyutu) — gerçek kullanım görüntü ayrıntısında yaşar.",
        infoTitle: 'Görüntü',
        infoSize: 'Sanal boyut',
        infoObjects: 'Nesneler (provisioned)',
        infoObjectSize: 'Nesne boyutu',
        infoPrefix: 'Nesne öneki',
        infoFormat: 'Biçim',
        infoFeatures: 'Feature',
        usageTitle: 'Gerçek kullanım (rbd du)',
        usageOf: '{provisioned} GiB provisioned üzerinden',
        usageHint: 'Doğası gereği thin: yalnızca yazılmış nesneler bayt kaplar.',
        watchersTitle: 'Watcher',
        noWatchers: 'Watcher yok — şu anda bu görüntüyü açık tutan yok',
        snapshotsTitle: 'RBD anlık görüntüleri',
        noSnapshots: 'Bu görüntüde RBD anlık görüntüsü yok',
        colSnapshot: 'Anlık görüntü',
        colProtected: 'Korumalı',
        colTimestamp: 'Oluşturulma',
        protected: 'korumalı',
        mappingTitle: 'Fiziksel eşleme (OSD seti)',
        mappingSampled: "Toplam {total} nesneden {sampled} tanesi örneklendi — dürüst bir özet: büyük görüntülerde set, havuzun TÜM OSD'lerine yakınsar (CRUSH nesneleri tüm havuza dağıtır).",
        mappingComplete: 'Tüm nesneler eşlendi ({total} / {total}).',
        objectQueryTitle: 'Tek bir nesneyi eşle',
        objectName: 'Nesne adı',
        objectHint: "RADOS nesne adları <önek>.<16-hex dizin> biçimindedir — ceph osd map, PG'yi ve OSD setlerini yanıtlar.",
        mapObject: 'Eşle',
        primary: 'birincil: osd.{osd}'
      },
      registerDevice: {
        title: 'OSD aygıtını kaydet',
        hint: "Canlı bir kümede kayıt, aygıtı da HAZIRLAR: düğüme bağlı otomatik bir görevle BlueStore OSD olur (asla boş kalmaz, 2026-07-24'te onaylandı). Bir aygıt, tüm filoda en fazla bir Ceph kümesine ait olur.",
        disk: 'Veri diski',
        diskHint: 'Düğümün bildirilen veri diskleri — ad ve seri numarası',
        noDeclared: 'Bu düğümde bildirilen veri diski yok — önce düğümün yerel ayarlarında işaretleyin',
        serialHint: 'Aygıtın seri numarası — kimlik pini',
        encrypted: "Bu OSD'yi şifrele (dmcrypt)",
        encryptedHint: 'OSD başına seçim (küme modu "OSD başına seçilir"): kayıt anında bu diskte donar — sonraki bir mod değişikliği onu asla yeniden yazmaz; bunu şifrele/şifreyi çöz satır eylemi yapar.',
        error: 'Kayıt reddedildi'
      },
      unregisterDevice: {
        title: 'Aygıtın kaydını kaldır',
        body: 'Yalnızca kayıt: {name}, bu kümenin OSD adayı olmaktan çıkar. Baytlarına dokunulmaz.',
        error: 'Kayıt kaldırma reddedildi'
      },
      deploy: {
        action: 'Dağıtımı yeniden dene',
        title: "Bootstrap'i yeniden dene",
        body: "Doğuş bootstrap'i geçerli yapılandırmadan yeniden çalışır: mon'lar başlar, kayıtlı her aygıt hazırlanır ve BlueStore OSD olarak etkinleştirilir. İşlem makro görev olarak çalışır — aşama kendiliğinden güncellenir.",
        started: 'Bootstrap başlatıldı — makro görev olarak sürer; aşama kendiliğinden güncellenir',
        error: 'Bootstrap reddedildi'
      },
      propose: {
        action: 'Depolama olarak öner',
        title: 'Depolama olarak öner',
        hintPool: "Mevcut '{name}' havuzu bir TVirt depolaması olur: havuzla sınırlı bir cephx kimliği keystore'a iner ve ceph-rbd depolaması hazır doğar. Öneri havuzu tüketir — asla havuz oluşturmaz.",
        hintFs: "Mevcut '{name}' dosya sistemi bir TVirt depolaması olur: dosya sistemiyle sınırlı bir cephx kimliği keystore'a iner ve cephfs depolaması hazır ve bağlanmış doğar. Öneri dosya sistemini tüketir — asla dosya sistemi oluşturmaz.",
        name: 'Depolama adı',
        nameHint: 'DNS-1123, scope içinde benzersiz — cephx kimliği adını ondan alır.',
        path: 'Dosya sistemi içindeki path',
        pathHint: 'Depolamanın bağladığı dosya sistemi içindeki mutlak path — emin değilseniz /.',
        alsoPropose: 'Hemen depolama olarak öner',
        alsoProposePoolHint: 'Oluşturmadan sonra aynı hareket, yeni doğan havuzu ceph-rbd depolaması olarak önerir — iki açık çağrı, tek dialog.',
        alsoProposeFsHint: 'Oluşturmadan sonra aynı hareket, yeni doğan dosya sistemini cephfs depolaması olarak önerir — iki açık çağrı, tek dialog.',
        guard: 'Depolama olarak öner — yalnızca healthy bir kümede',
        started: 'Öneri kabul edildi — depolama şekilleniyor; onu Depolama altında bulursunuz',
        submit: 'Depolama oluştur',
        error: 'Öneri reddedildi'
      },
      fs: {
        section: 'Dosya sistemleri',
        create: 'Dosya sistemi oluştur',
        createGuard: 'Dosya sistemleri yalnızca dağıtılmış bir kümede var olur',
        mdsFirstGuard: 'Önce bir MDS ekleyin — metadata server olmadan bir dosya sistemi hizmet veremez halde doğar',
        notObserved: "Dosya sistemi gözlemi yok — MON sweep'i buraya raporlar",
        empty: 'Kümede dosya sistemi yok',
        colName: 'Ad',
        colPools: 'Havuzlar',
        colMds: 'MDS',
        noActiveMds: 'etkin MDS yok',
        delete: 'Dosya sistemini kaldır',
        deleteGuard: "'{name}' depolaması tarafından tüketiliyor — önce depolamayı silin",
        hint: "Bir dosya sistemi, veri ve metadata havuzlarının sahibidir (cephfs.<ad>.data / .meta): onunla doğar, onunla ölürler — removeFs, asla elle bir havuz silme. Bu tablo, MON sweep'inden gözlemlenen gerçektir.",
        createTitle: 'Dosya sistemi oluştur',
        createHint: 'Dosya sistemi, iki havuzuyla (application cephfs) kümede doğar ve bildirilen MDS\'ler tarafından sunulur — işi bir MON düğümündeki görev yapar. Aynı harekette hemen tüketmek için "Depolama olarak öner" seçeneğini açın.',
        name: 'Dosya sistemi adı',
        nameHint: 'DNS-safe (küçük harfler, rakamlar, tireler).',
        sizeHint: 'Yeni doğan HER İKİ havuzun replikaları. Varsayılan 3.',
        createError: 'Dosya sistemi oluşturma reddedildi',
        deleteTitle: 'Dosya sistemini kaldır',
        deleteBody: "'{fs}' dosya sistemi ve içindeki HER dosya geri dönülmez biçimde yok edilir — veri ve metadata havuzları onunla birlikte ölür. Onaylamak için dosya sisteminin adını yazın.",
        confirmLabel: 'Dosya sistemi adı',
        confirmHint: 'Onaylamak için dosya sisteminin adını yazın',
        deleteError: 'Dosya sistemi kaldırma reddedildi'
      },
      destroy: {
        action: 'Yok et',
        retryAction: 'Yok etmeyi yeniden dene',
        retryGuard: 'Yok etme çalışıyor — yeniden deneme başarısız bir yok etme içindir (aksi halde lease reddeder)',
        title: 'Kümeyi yok et',
        body: "Dağıtılmış fabric sökülür: bu kümenin her daemon'ı durur, sistem durumu ve keystore'daki anahtarları serbest bırakılır. Yok etme başarıyla bitince küme otomatik olarak kaldırılır.",
        confirmLabel: 'Küme adı',
        confirmHint: 'Onaylamak için kümenin adını yazın',
        wipe: 'Kayıtlı aygıtları temizle',
        wipeHint: 'İşaretli: kayıtlı her aygıtın imzaları temizlenir — üzerindeki veriler yok edilir. İşaretsiz: baytlar olduğu gibi kalır ve aygıtlar kayıtlı durumuna döner.',
        guard: 'Yok et — dağıtılmış bir şey yok',
        started: 'Yok etme başlatıldı — makro görev olarak sürer; aşama kendiliğinden güncellenir',
        error: 'Yok etme reddedildi'
      },
      delete: {
        guard: 'Sil — yalnızca dağıtılmamış bir yapılandırma (önce yok edin)',
        title: "'{name}' silinsin mi?",
        body: 'Yapılandırma ve aygıt kaydı kaldırılır. Yalnızca hiçbir şey dağıtılmamışken geçerlidir.',
        error: 'Silme reddedildi'
      }
    }
  }
}
